import {
  FDBodyText, FDDisplayText, FDHeadlineText, FDLabelText, FDTitleText,
} from '@facet-wealth/design';
import React from 'react';
import { inputDefaultProps, inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import { useDataAttrs } from 'Helpers/Testing';
import PropTypes from 'prop-types';

export const Text = (props) => {
  const {
    Component,
    align,
    flexGrow,
    flexShrink,
    fullWidth,
    disabled,
    error,
    helperTextValue,
    label,
    onBlur,
    onChange,
    min,
    max,
    onFocus,
    placeholder,
    readonly,
    required,
    size,
    value,
    color,
    ...rest
  } = props;

  return (
    <Component
      {...useDataAttrs(rest)}
      align={align}
      disabled={disabled || readonly}
      error={error}
      minLength={min}
      maxLength={max}
      flexGrow={flexGrow}
      flexShrink={flexShrink}
      fullWidth={fullWidth}
      helperText={helperTextValue}
      label={label}
      onBlur={onBlur}
      onChange={(val) => (val === undefined ? onChange('') : onChange(val))}
      onFocus={onFocus}
      placeholder={placeholder}
      required={required}
      size={size}
      value={value === '' ? undefined : value}
      color={color}
    />
  );
};

Text.defaultProps = {
  align: inputDefaultProps.align,
  color: undefined,
};

Text.propTypes = {
  Component: PropTypes.element.isRequired,
  align: inputPropTypes.align,
  size: inputPropTypes.textSize.isRequired,
  value: inputPropTypes.value.isRequired,
  color: PropTypes.string,
};

export const LabelTextSmall = (props) => <Text {...props} Component={FDLabelText} size="sm" />;
export const LabelTextMedium = (props) => <Text {...props} Component={FDLabelText} size="md" />;
export const LabelTextLarge = (props) => <Text {...props} Component={FDLabelText} size="lg" />;

export const BodyTextSmall = (props) => <Text {...props} Component={FDBodyText} size="sm" />;
export const BodyTextMedium = (props) => <Text {...props} Component={FDBodyText} size="md" />;
export const BodyTextLarge = (props) => <Text {...props} Component={FDBodyText} size="lg" />;

export const TitleTextSmall = (props) => <Text {...props} Component={FDTitleText} size="sm" />;
export const TitleTextMedium = (props) => <Text {...props} Component={FDTitleText} size="md" />;
export const TitleTextLarge = (props) => <Text {...props} Component={FDTitleText} size="lg" />;

export const HeadlineTextSmall = (props) => <Text {...props} Component={FDHeadlineText} size="sm" />;
export const HeadlineTextMedium = (props) => <Text {...props} Component={FDHeadlineText} size="md" />;
export const HeadlineTextLarge = (props) => <Text {...props} Component={FDHeadlineText} size="lg" />;

export const DisplayTextSmall = (props) => <Text {...props} Component={FDDisplayText} size="sm" />;
export const DisplayTextMedium = (props) => <Text {...props} Component={FDDisplayText} size="md" />;
export const DisplayTextLarge = (props) => <Text {...props} Component={FDDisplayText} size="lg" />;
